import { AlertTriangle } from 'lucide-react'
import type { ReactNode } from 'react'
import { formatEuros } from '@/lib/format'
import { cn } from '@/lib/utils'

interface Props {
  amount: number
  headline: string
  description: string
  action?: ReactNode
  className?: string
}

/**
 * Een aggregaat boven een lijst dat geen enkele rij kan geven: hoeveel geld er
 * vastloopt. Het bedrag staat voorop, want dat zegt meer dan een aantal regels of
 * dagen. Gebruikt door het uitbetaaloverzicht en de facturenlijst.
 */
export function AttentionStrip({ amount, headline, description, action, className }: Props) {
  return (
    <div
      className={cn(
        'flex items-center gap-3.5 rounded-card bg-status-overdue/6 px-5 py-3.5 ring-1 ring-inset ring-status-overdue/20',
        className,
      )}
    >
      <AlertTriangle className="h-[18px] w-[18px] shrink-0 text-status-overdue" strokeWidth={1.85} />
      <span className="min-w-0 flex-1">
        <span className="block text-sm text-ink">
          <span className="money font-semibold text-status-overdue">{formatEuros(amount)}</span> {headline}
        </span>
        <span className="block text-xs text-ink-faint">{description}</span>
      </span>
      {action ? <span className="shrink-0">{action}</span> : null}
    </div>
  )
}
